import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div ``;
export const IconGrid = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const squares = wrapperRef.current?.querySelectorAll('svg > g > path');
            const firstLine = wrapperRef.current?.querySelector('svg > g g path:first-child');
            const lastLine = wrapperRef.current?.querySelectorAll('svg > g g path:last-child');
            if (squares && firstLine && lastLine) {
                gsap.to(squares, {
                    stagger: 0.1,
                    keyframes: [
                        {
                            rotateZ: '18deg',
                            scale: 1.15,
                            duration: 0.1,
                        },
                        {
                            rotateZ: '0deg',
                            scale: 0.85,
                            duration: 0.2,
                        },
                        {
                            scale: 1,
                            duration: 0.15,
                        },
                    ],
                });
                gsap.to(firstLine, {
                    delay: 0.4,
                    duration: 0.25,
                    strokeDashoffset: '20px',
                    clearProps: true,
                });
                gsap.to(lastLine, {
                    delay: 0.45,
                    duration: 0.25,
                    strokeDashoffset: '0px',
                    clearProps: true,
                    onComplete: () => {
                        triggerDone();
                    },
                });
            }
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Grid, null)));
};
//# sourceMappingURL=Grid.js.map